// @ts-nocheck
import { MODULE_ACL, USER_ROLES } from "./constant";
import { isAclModuleOptionsRelevant } from "./aclModuleOptionsAccess";
import { parseModuleOperations } from "./voicePlanAcl";

export const CALL_CENTRE_ACL_MODULE = MODULE_ACL.CALL_CENTRE;
export const VOICEMAIL_ACL_OPTION = "voicemail";
export const DEFAULT_CALL_CENTRE_EDIT_OPTIONS = [];
export const STORAGE_QUOTA_OPTIONS = [500, 1000];
export const DEFAULT_STORAGE_QUOTA = 500;

function isSuperAdminRole(userRole, isSuperAdmin) {
  return isSuperAdmin || userRole === USER_ROLES.SUPERADMIN;
}

export function getCallCentreAclEntry(moduleOperations) {
  const ops = parseModuleOperations(moduleOperations);
  return ops[CALL_CENTRE_ACL_MODULE] || null;
}

export function normalizeCallCentreEditOptions(options) {
  if (!Array.isArray(options)) return [];
  return [
    ...new Set(
      options
        .map((o) => String(o).trim())
        .filter((o) => o === VOICEMAIL_ACL_OPTION)
    ),
  ];
}

export function hasCallCentreVoicemailAcl(
  moduleOperations,
  { userRole = null, isSuperAdmin = false } = {}
) {
  if (isSuperAdminRole(userRole, isSuperAdmin)) {
    return true;
  }

  const entry = getCallCentreAclEntry(moduleOperations);
  if (!entry?.edit && !entry?.add) {
    return false;
  }

  // Legacy ACLs (before voicemail options): no edit_options field → all options allowed.
  if (!Array.isArray(entry.edit_options)) {
    return true;
  }

  return normalizeCallCentreEditOptions(entry.edit_options).includes(
    VOICEMAIL_ACL_OPTION
  );
}

export function getSelectableStorageQuotas(
  moduleOperations,
  { userRole = null, isSuperAdmin = false } = {}
) {
  if (!hasCallCentreVoicemailAcl(moduleOperations, { userRole, isSuperAdmin })) {
    return [];
  }
  return [...STORAGE_QUOTA_OPTIONS];
}

export function isCallCentreVoicemailEnabled(callCentre) {
  if (!callCentre) return false;
  return (
    callCentre.is_voicemail_enabled === true ||
    callCentre.is_voicemail_enabled === 1
  );
}

export function canManageChildVoicemail(callCentre) {
  return isCallCentreVoicemailEnabled(callCentre);
}

export function isCallCentreVoicemailAclConfigured(moduleEntry) {
  if (!moduleEntry?.edit && !moduleEntry?.add) return false;
  return Array.isArray(moduleEntry.edit_options);
}

export function getParentGrantableCallCentreVoicemail(moduleOperations, isSuperAdmin) {
  if (isSuperAdmin) {
    return { canGrantVoicemail: true };
  }
  const entry = getCallCentreAclEntry(moduleOperations);
  if (!entry?.add && !entry?.edit) {
    return { canGrantVoicemail: false };
  }
  if (!Array.isArray(entry?.edit_options)) {
    return { canGrantVoicemail: true };
  }
  return {
    canGrantVoicemail: normalizeCallCentreEditOptions(entry.edit_options).includes(
      VOICEMAIL_ACL_OPTION
    ),
  };
}

export function normalizeCallCentreVoicemailAclForSave(
  { edit_options = [] } = {},
  parentGrantable = null
) {
  let options = normalizeCallCentreEditOptions(edit_options);
  if (parentGrantable && !parentGrantable.canGrantVoicemail) {
    options = [];
  }
  return { edit_options: options };
}

export function formatCallCentreVoicemailAclLabel(moduleEntry) {
  if (!isAclModuleOptionsRelevant(moduleEntry)) return "—";
  const options = normalizeCallCentreEditOptions(moduleEntry.edit_options);
  if (options.length === 0) return "—";
  if (!options.includes(VOICEMAIL_ACL_OPTION)) return "—";
  return "Voicemail";
}

export function getUserModuleOperations(user) {
  if (!user) return {};
  const raw =
    user?.acl_settings?.module_operations ?? user?.module_operations ?? null;
  return parseModuleOperations(raw);
}

export function getAssignedCallCentreId(user) {
  if (!user) return null;
  const id = user.assigned_call_center ?? user.assignedCallCenter?.id ?? null;
  if (id == null || id === "") return null;
  return id;
}

export function readVoicemailEnabled(record) {
  if (!record) return false;
  return (
    record.is_voicemail_enabled === true ||
    record.is_voicemail_enabled === 1
  );
}
